import { Button, Col, Form, Modal, Row, Space } from 'antd';
import { Documents } from 'features/documents/models';
import { Expedition } from 'features/logistics/models';
import { useEffect } from 'react';
import useStateCallback from 'shared/hooks/useStateCallback';

const ExpeditionDuplicateModal = ({
  isOpenModal,
  onCancel,
  onSubmit,
  dataExpeditionDuplicate,
  document,
}: {
  isOpenModal: boolean;
  onCancel: (isShowDuplicateModal: boolean) => void;
  onSubmit: () => void;
  dataExpeditionDuplicate: Expedition[];
  document: Documents | null;
}) => {
  const [form] = Form.useForm();
  const [expeditionSelected, setExpeditionSelected] = useStateCallback<Expedition | null>(null);
  const handleCancel = () => {
    onCancel(false);
  };
  const handleSubmit = async () => {
    onSubmit();
  };

  useEffect(() => {
    console.log(expeditionSelected);
  }, [expeditionSelected]);
  return (
    <Modal
      title='Commande rotation'
      open={isOpenModal}
      maskClosable={false}
      onCancel={handleCancel}
      className='expedition-duplicate-modal'
      width={600}
      centered
      footer={[
        <Button key='annuler' onClick={handleCancel} className='ant-modal-content__cancel-btn'>
          Non
        </Button>,
        expeditionSelected && (
          <Button key='ajouter' type='primary' className='ant-modal-content__add-btn' onClick={handleSubmit}>
            Créer une rotation
          </Button>
        ),
      ]}
    >
      <Space direction='vertical'>
        <Form form={form} autoComplete='off'>
          <p>
            <i>Nous avons détecté une ou plusieurs expéditions similaires.</i>
          </p>
          <p>
            <i>Souhaitez-vous transformer votre commande actuelle en rotation?</i>
          </p>
          <div className='mx-5'>
            {dataExpeditionDuplicate?.map((obj) => (
              <div
                onClick={() => setExpeditionSelected(obj)}
                className={`my-5 expedition-duplicate-modal__selectbox ${obj.id == expeditionSelected?.id ? 'active' : ''}`}
                key={obj.id}
              >
                <Row>
                  <Col span={20}>
                    <p>Numéro de commande : {document?.cdeZoho}</p>
                    <p>Adresse chantier : {document?.siteAddressFull}</p>
                    <p>Client : {document?.Contact?.name}</p>
                    <p>Statut : {obj.ExpeditionStatus?.name}</p>
                  </Col>
                  <Col span={4} className='center-item'>
                    <p>Choisir</p>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </Form>
      </Space>
    </Modal>
  );
};
export default ExpeditionDuplicateModal;
